module.exports = __webpack_public_path__ + "img/science_icon.6689669c.png";